
import { defineComponent, computed, inject } from 'vue';
import { useVModel } from 'vue-composable';
import surveyService from '@/services/survey-service';
import { Survey } from '@/types';
import { ShowToast } from '@/providers/Toast/toast-types';

export default defineComponent({
  name: 'ConfirmHideContactsChangeModal',
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    survey: {
      type: Object as () => Survey | null,
      required: true
    }
  },
  setup(props, { emit }) {
    const surveyRef = computed(() => props.survey);
    const showModalRef = useVModel(props, 'showModal');
    const showToast = inject<ShowToast>('showToast')!;

    const closeModal = () => {
      emit('resetHideContacts');
      showModalRef.value = false;
    };

    const confirmHideContactsChange = async () => {
      if (!surveyRef.value) return;
      const response = await surveyService.update({ ...surveyRef.value, hideContactsOnShare: !surveyRef.value.hideContactsOnShare });

      let messageText = '';
      if (response) {
        messageText = surveyRef.value.hideContactsOnShare ? 'Contacts are now visible' : 'Contacts are now hidden';
        showToast({
          headline: 'Success',
          message: messageText,
          color: 'success'
        });

        emit('updateSurvey', surveyRef.value);
        surveyRef.value.hideContactsOnShare = !surveyRef.value.hideContactsOnShare;
        closeModal();
      } else {
        messageText = surveyRef.value.hideContactsOnShare ? 'Failed to hide contacts' : 'Failed to show contacts';
        showToast({
          headline: 'Error',
          message: messageText,
          color: 'danger'
        });
        closeModal();
      }
    };
    return {
      surveyRef,
      closeModal,
      confirmHideContactsChange,
      showModalRef
    };
  }
});
